<template>
  <v-container class="pa-0" fluid>
    <!-- 팝업 파일 -->
    <i-dxpopup
      :popupVisible="popupVisible"
      :title="$t(popupTitle)"
      :key="componentKey"
      @popupCloseButtonClick="popupCloseButtonClick"
      :vHtmlContent="'test'"
      :height="popupHeight"
      :width="popupWidth"
    >
      <template v-slot:grid>
        <i-file-upload
          if="mode == 'file'"
          :headerTitle="$t('muscleHazardSearchFileManage')"
          :targetId="targetId"
          :targetType="targetType"
          @fileListChange="fileListChange(targetId, $event)"
        >
        </i-file-upload>
      </template>
    </i-dxpopup>
    <!-- 버튼 영역 (조회, 추가, 저장, 삭제) -->
    <v-row class="mb-1 innerGrid" no-gutters>
      <i-card-top
        class="d-md-flex"
        :useBtnList="buttonUseList"
        @btnAdd="btnAdd()"
        @btnSearch="btnSearch(true)"
        @btnSave="btnSave()"
        @btnDelete="btnDelete()"
      >
        <template v-slot:body>
          <div></div>
        </template>
      </i-card-top>
      <v-spacer />
    </v-row>
    <!-- 그리드 영역 -->
    <v-col cols="12" lg="12" class="mt-0 pa-0">
      <DxDataGrid
        :ref="detailRef"
        width="100%"
        height="250px"
        :data-source="gridMain"
        :remote-operations="false"
        :hover-state-enabled="true"
        :allow-column-resizing="true"
        :allow-column-reordering="true"
        :row-alternation-enabled="true"
        :column-auto-width="true"
        :show-borders="true"
        :show-row-lines="true"
        :focused-row-enabled="true"
        :column-hiding-enabled="false"
        key-expr="id"
        :on-content-ready="null"
        @editing-start="onEditingStart"
        @editor-preparing="onEditorPreparing"
        @focused-row-changed="onFocusedRowChanged"
      >
        <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

        <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" />

        <DxColumn data-field="compId" data-type="string" :visible="false"> </DxColumn>

        <DxColumn
          data-field="unitWorkName"
          :caption="$t('unitWorkName')"
          width="100px"
          data-type="string"
          css-class="devest-grid-header-require"
          :hiding-priority="14"
        />

        <DxColumn
          data-field="part"
          :caption="$t('part')"
          width="120px"
          data-type="string"
          css-class="devest-grid-header-require"
          :hiding-priority="13"
          :calculate-display-value="e => parseSplit(this.partList, e.part, ',')"
          edit-cell-template="parseSplitEditorPart"
        >
        </DxColumn>
        <template #parseSplitEditorPart="{ data: cellInfo }">
          <DxTagBox
            :data-source="partList"
            :v-model="setTagBoxValue(cellInfo.value)"
            :value="setTagBoxValue(cellInfo.value)"
            :show-selection-controls="true"
            display-expr="minorNm"
            value-expr="minorCd"
            :search-enabled="true"
            :active-state-enabled="false"
            @value-changed="onTagValueChanged($event, cellInfo)"
          >
          </DxTagBox>
        </template>
        <!-- <DxLookup :data-source="partList" value-expr="minorCd" display-expr="minorNm" /> -->

        <DxColumn
          data-field="heavyWork"
          :caption="$t('heavyWork')"
          width="100px"
          data-type="string"
          css-class="devest-grid-header-require"
          alignment="left"
          :calculate-display-value="e => parseSplit(this.heavyWorkList, e.heavyWork, ',')"
          edit-cell-template="parseSplitEditorHeavyWork"
        >
        </DxColumn>
        <template #parseSplitEditorHeavyWork="{ data: cellInfo }">
          <DxTagBox
            :data-source="heavyWorkList"
            :v-model="setTagBoxValue(cellInfo.value)"
            :value="setTagBoxValue(cellInfo.value)"
            :show-selection-controls="true"
            :display-expr="e => displayTemplate(e)"
            :dropDownOptions="{ width: '1000px' }"
            value-expr="minorCd"
            :search-enabled="true"
            @value-changed="onTagValueChanged($event, cellInfo)"
          >
          </DxTagBox>
        </template>

        <DxColumn
          data-field="workBuha"
          :caption="`${$t('workBurden')}(A)`"
          width="100px"
          data-type="string"
          css-class="devest-grid-header-require"
          :hiding-priority="11"
        >
          <DxLookup :data-source="workBuhaList" value-expr="minorNm" :display-expr="e => displayTemplate(e)" />
        </DxColumn>

        <DxColumn
          data-field="workFrequency"
          :caption="`${$t('workFrequency')}(B)`"
          width="220px"
          data-type="string"
          css-class="devest-grid-header-require"
          :hiding-priority="10"
        >
          <DxLookup :data-source="workFrequencyList" value-expr="minorNm" :display-expr="e => displayTemplate(e)" />
        </DxColumn>

        <template #commonMultiSelector="{ data: cellInfo }">
          <DxDropDownBox
            :ref="`commonMultiSelectorRef${cellInfo.key}`"
            :value="(cellInfo.value && cellInfo.value.toString().split(',')) || null"
            :drop-down-options="{ width: 470 }"
            :defer-rendering="false"
            display-expr="minorNm"
            value-expr="minorCd"
          >
            <DxDataGrid
              :selected-row-keys="(cellInfo.value && cellInfo.value.split(',')) || null"
              :data-source="getCommonList(cellInfo.column.dataField)"
              :height="280"
              :hover-state-enabled="true"
              :editing="{ allowUpdating: false }"
              :selection="{ deferred: false }"
              :filter-row="{ visible: true }"
              :paging="{ pageSize: 5 }"
              :pager="{ allowedPageSizes: [5, 'all'], showInfo: false }"
              key-expr="minorCd"
              @selection-changed="
                e => {
                  // $refs[`commonMultiSelectorRef${cellInfo.key}`].instance.option('value', e.selectedRowKeys)
                  // cellInfo.setValue(e.selectedRowKeys)
                  // cellInfo.component.selectRows(cellInfo.row.key, true)
                }
              "
              :on-initialized="() => null"
              :on-content-ready="() => null"
              @initialized="onDropdownEditGridInitialized"
              class="sec_grid"
            >
              <DxColumn data-field="minorCd" caption="상세코드" width="140px" alignment="left" />
              <DxColumn data-field="minorNm" caption="상세코드명" width="140px" alignment="left" />
              <DxColumn data-field="minorDesc" caption="내용" data-type="string" alignment="left" />
              <DxColumn data-field="remark" caption="비고" data-type="string" width="250px" alignment="left" />
            </DxDataGrid>
          </DxDropDownBox>
        </template>

        <template #commonSelector="{ data: cellInfo }">
          <DxDropDownBox
            :ref="`commonSelectorRef${cellInfo.key}`"
            :value="cellInfo.value"
            :drop-down-options="{ width: 470 }"
            :defer-rendering="false"
            display-expr="minorNm"
            value-expr="minorCd"
          >
            <!-- :selected-row-keys="(cellInfo.value) || null" -->
            <DxDataGrid
              :selected-row-keys="[cellInfo.value] || null"
              :data-source="getCommonList(cellInfo.column.dataField)"
              :height="280"
              :hover-state-enabled="false"
              :editing="{ allowUpdating: false }"
              :selection="{ deferred: false, mode: 'single' }"
              :filter-row="{ visible: true }"
              :paging="{ pageSize: 5 }"
              :pager="{ allowedPageSizes: [5, 'all'], showInfo: false }"
              key-expr="minorCd"
              :on-initialized="() => null"
              :on-content-ready="() => null"
              @initialized="onDropdownEditGridInitialized"
              class="sec_grid"
            >
              <DxColumn data-field="minorCd" caption="상세코드" width="140px" alignment="left" />
              <DxColumn data-field="minorNm" caption="상세코드명" width="140px" alignment="left" />
              <DxColumn data-field="minorDesc" caption="내용" data-type="string" alignment="left" />
              <DxColumn data-field="remark" caption="비고" data-type="string" width="250px" alignment="left" />
            </DxDataGrid>
          </DxDropDownBox>
        </template>

        <DxColumn
          data-field="workCal"
          :caption="`${$t('totalScore')}(A×B)`"
          width="95px"
          alignment="center"
          data-type="string"
          :hiding-priority="9"
          :allow-editing="false"
        />
        <DxColumn
          data-field="hazardFactor"
          :caption="$t('hazardFactor')"
          data-type="string"
          css-class="devest-grid-header-require"
          cell-template="sub-dx-datagrid"
          edit-cell-template="sub-dx-datagrid"
          :hiding-priority="7"
          width="100px"
        />

        <DxColumn
          data-field="hazardFactorCause"
          :caption="$t('sourceOrExposureCharacteristics')"
          data-type="string"
          css-class="devest-grid-header-require"
          cell-template="sub-dx-datagrid"
          edit-cell-template="sub-dx-datagrid"
          :hiding-priority="6"
          width="250px"
        />
        <DxColumn
          data-field="unitWorkDetail"
          :caption="$t('unitWorkDetail')"
          data-type="string"
          cell-template="sub-dx-datagrid"
          edit-cell-template="sub-dx-datagrid"
          :hiding-priority="8"
        />

        <DxColumn
          data-field="workerOpinion"
          :caption="$t('workerOpinion')"
          data-type="string"
          cell-template="sub-dx-datagrid"
          edit-cell-template="sub-dx-datagrid"
          :hiding-priority="3"
          width="100px"
        />

        <DxColumn
          data-field="processDate"
          :caption="$t('processSchedule')"
          width="100px"
          data-type="date"
          alignment="center"
          format="yyyy.MM.dd"
          :hiding-priority="2"
        >
        </DxColumn>

        <DxColumn
          data-field="improvementMethod"
          :caption="$t('improvement')"
          data-type="string"
          cell-template="sub-dx-datagrid"
          edit-cell-template="sub-dx-datagrid"
          :hiding-priority="1"
        />

        <DxColumn
          data-field="improvementCost"
          :caption="$t('improvementCost')"
          data-type="number"
          alignment="right"
          format="###,###,###"
          :hiding-priority="0"
          width="100px"
        />

        <DxColumn
          data-field="remark"
          :caption="$t('remark')"
          data-type="string"
          cell-template="sub-dx-datagrid"
          edit-cell-template="sub-dx-datagrid"
          :hiding-priority="5"
          width="100px"
        />

        <DxColumn
          data-field="fileNm"
          data-type="string"
          width="150px"
          alignment="center"
          :caption="$t('fileManagement')"
          :allow-editing="true"
          cell-template="file-manage-template"
          edit-cell-template="file-manage-template"
          :hiding-priority="4"
        >
        </DxColumn>
        <template #file-manage-template="{ data: cellInfo }">
          <v-row v-if="!cellInfo.data.__created__" no-gutters class="pr-2" style="flex-flow: nowrap">
            <div class="pl-2" style="text-overflow: ellipsis; overflow: hidden;">
              {{ cellInfo.data.fileNm }}
            </div>
            <div>
              {{ cellInfo.data.fileCount }}
            </div>

            <v-col align="right">
              <v-btn x-small class="pa-0" color="primary" icon @click="ShowPopup('단위작업별 유해요인 목록', cellInfo, 'file')">
                <svg-icon icon-class="preview" style="height: 1rem"></svg-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>

        <template #sub-dx-datagrid="{ data: cellInfo }">
          <div>
            <!-- :min-height="55" -->
            <DxTextArea
              :ref="`subDxTextAra${cellInfo.row.rowIndex}`"
              :auto-resize-enabled="true"
              v-model="cellInfo.value"
              :on-value-changed="
                e => {
                  cellInfo.setValue(e.value, e.value)
                  cellInfo.component.selectRows(cellInfo.row.key, true)
                }
              "
              :on-key-down="
                e => {
                  if (e.event.keyCode == 13) {
                    e.event.stopPropagation()
                  }
                }
              "
            />
          </div>
        </template>
      </DxDataGrid>
    </v-col>
  </v-container>
</template>

<script>
import iDxPopup from '@/components/common/iDxPopup.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import DxDropDownBox from 'devextreme-vue/drop-down-box'

import { getCommonCode } from '@/api/common/commonApi'

import IFileUpload from '@/components/common/iFileUpload.vue'
import { DxColumn, DxDataGrid, DxEditing, DxLookup, DxPager, DxPaging, DxScrolling, DxSelection } from 'devextreme-vue/data-grid'
import DxTagBox from 'devextreme-vue/tag-box'

import { getMuscleHazardSearchDetail, saveMuscleHazardSearchDetail, deleteMuscleHazardSearchDetail } from '@/api/healthcare/muscleHazardSearch'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  components: {
    DxDropDownBox,
    'i-dxpopup': iDxPopup,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxTagBox,
    IFileUpload,
    DxSelection
  },
  props: {
    masterDetailData: {
      type: Object,
      default: () => ({})
    },
    detailRef: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave',
        'btnDelete'
      ],
      gridMain: [],

      partList: [], //부위(공통코드:C0047)
      heavyWorkList: [], //부담작업(호)(공통코드:C0048)
      workBuhaList: [], //작업부하(A)(공통코드:C0050)
      workFrequencyList: [], //작업빈도(B)(공통코드:C0049)

      // file popup
      componentKey: 0,
      // mode : '', // hazardFactors : 표준 유해 요인, file : 파일 업로드
      targetId: '',
      targetType: 'muscle_hazard_d',
      mode: '',
      popupHeight: '',
      popupWidth: '',
      popupVisible: false,
      popupTitle: 'fileManagement',
      selectedInfo: [],
      selectedFile: [],
      selectedRowsData: [],
      selectionChangedBySelectBox: false
    }
  },
  computed: {
    console: () => console,
    dataGridMain: function() {
      return this.$refs[this.detailRef].instance
    }
  },
  beforeMount() {
    this.getLookupData()
  },
  mounted() {},
  methods: {
    async btnSave() {
      this.GetDataGrid(this.detailRef).beginUpdate()
      this.GetDataGrid(this.detailRef).saveEditData()
      var selectedRows = await this.GetDataGrid(this.detailRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'warn')
        this.GetDataGrid(this.detailRef).endUpdate()
        return
      }
      let detailIndex = selectedRows.findIndex(
        element =>
          //조사구분
          element.unitWorkName == null ||
          element.unitWorkName.trim() == '' ||
          //조사일자
          element.part == null ||
          element.part == '' ||
          //부서명
          element.heavyWork == null ||
          element.heavyWork == '' ||
          //작업공정명
          element.workBuha == null ||
          element.workBuha == '' ||
          //작업명
          element.workCal == null ||
          element.workCal == '' ||
          //조사자
          element.hazardFactor == null ||
          element.hazardFactor == '' ||
          //근로자
          element.hazardFactorCause == null ||
          element.hazardFactorCause == ''
      )
      if (detailIndex >= 0) {
        this.vToastify(
          `${this.$t('msgReqValidate')}[${this.$t('unitWorkName')},${this.$t('part')},${this.$t('heavyWork')},${this.$t('workBurden')},${this.$t(
            'WorkFrequency'
          )},\n${this.$t('hazardFactor')},${this.$t('sourceOrExposureCharacteristics')}]`,
          'warn'
        )
        this.GetDataGrid(this.detailRef).endUpdate()
        return
      }
      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        current => {
          this.openLoading('saving')
          saveMuscleHazardSearchDetail([selectedRows], true)
            .then(res => {
              if (res.code === -2000) {
                this.vToastify(`${this.$t('msgDuplicateData')}\n[${this.$t('unitWorkName')},${this.$t('part')}]`, 'warn')
              } else {
                this.btnSearch(false)
              }
            })
            .finally(() => {
              this.endLoading()
              this.GetDataGrid(this.detailRef).endUpdate()
            })
        },
        false,
        false
      )
    },

    getCommonList(fieldName) {
      let returnList

      switch (fieldName) {
        case 'heavyWork':
          returnList = this.heavyWorkList
          break
        case 'workBuha':
          returnList = this.workBuhaList
          break
        case 'workFrequency':
          returnList = this.workFrequencyList
          break
        default:
          break
      }

      return returnList
    },
    // 팝업의 변경된 props들을 반영하기 위해 사용
    forceRerender() {
      this.componentKey += 1
    },
    async btnDelete() {
      let createdRows = []
      let selectedRows = []
      var allSelectedRows = await this.GetDataGrid(this.detailRef).getSelectedRowsData()
      if (allSelectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'warn')
        return
      }
      allSelectedRows.forEach(item => {
        if (item.__created__ == true) createdRows.push(item)
        else selectedRows.push(item)
      })
      if (selectedRows.length === 0) {
        this.deleteCallBack(createdRows)
        return
      }
      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        current => {
          this.GetDataGrid(this.detailRef).beginUpdate()
          this.GetDataGrid(this.detailRef).saveEditData()
          deleteMuscleHazardSearchDetail([selectedRows], true)
            .then(res => {
              if (res.success) {
                this.deleteCallBack(allSelectedRows)
              }
            })
            .catch(error => {})
            .finally(() => {
              this.GetDataGrid(this.detailRef).endUpdate()
              this.endLoading()
              this.btnSearch()
            })
        },
        null,
        true
      )
    },
    btnAdd() {
      let newRow = {
        id: this.gridMain.length + 1,
        seq: this.masterDetailData.data.seq,
        compId: this.getCompId()
      }

      Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })

      this.dataGridMain.newRow(newRow)
      this.GetDataGrid(this.detailRef).selectRows(newRow.id, true)
    },
    btnSearch(isProgress) {
      this.openLoading('searching')

      let searchParams = {
        seq: this.masterDetailData.data.seq,
        compId: this.masterDetailData.data.compId
      }
      getMuscleHazardSearchDetail(searchParams, isProgress)
        .then(res => {
          this.gridInit(this.GetDataGrid(this.detailRef))

          this.gridMain = []
          this.gridMain = res.list
          this.FocusFirstRow(this.GetDataGrid(this.detailRef))
        })
        .finally(() => {
          this.endLoading()
        })
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    getLookupData() {
      // this.openLoading()
      Promise.all([
        getCommonCode('C0047'),
        getCommonCode('C0048'),
        getCommonCode('C0050'),
        getCommonCode('C0049'),
        getMuscleHazardSearchDetail({ compId: this.masterDetailData.data.compId, seq: this.masterDetailData.data.seq })
      ]).then(response => {
        this.partList = response[0].list //부위
        this.heavyWorkList = response[1].list //부담작업(호)
        this.workBuhaList = response[2].list //작업부하(A)
        this.workFrequencyList = response[3].list //작업빈도(B)
        this.gridMain = response[4].list
      })
    },
    ///////////////////////////////////////
    /*         DataGrid   Event          */
    ///////////////////////////////////////
    onEditingStart(e) {
      // if (e.column.dataField == 'useYn') e.cancel = false
      // else e.cancel = true
      var valueChanged = this.onCellValueChanged

      if (e.parentType == 'dataRow') {
        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) {
            valueChanged(args.value, e)
          }
        }
      }
    },
    async onCellValueChanged(value, cellInfo) {
      cellInfo.setValue(value)
      this.GetDataGrid(this.detailRef).selectRows(cellInfo.row.key, true)

      if (cellInfo.dataField == 'workBuha' || cellInfo.dataField == 'workFrequency') {
        this.setWorkCal(cellInfo, cellInfo.row.data.workBuha, cellInfo.row.data.workFrequency)
      }
    },
    //총점수 계산
    setWorkCal(cellInfo, valWorkBuha, valWorkFrequency) {
      let valWorkCal = valWorkBuha * valWorkFrequency

      if (isNaN(valWorkCal)) {
        valWorkCal = null
      }

      //총점수
      this.GetDataGrid(this.detailRef).cellValue(cellInfo.row.rowIndex, 'workCal', valWorkCal)
    },
    ShowPopup(title, cellInfo, mode) {
      if (mode == 'file') {
        this.targetId = cellInfo.data.unitSeq
        this.popupHeight = '590'
        this.popupWidth = '50vw'
        // 팝업의 변경된 props들을 반영하기 위해 사용
      }
      this.forceRerender()
      this.popupVisible = true
    },
    onClosedPopUp() {
      this.popupVisible = false
    },
    openFilePopup(data) {
      if (this.selectedInfo.length == 0) {
        this.selectedInfo = cellInfo.row
      }
    },
    popupCloseButtonClick() {
      this.popupVisible = false
    },
    // string값을 배열값으로 변환시켜 넣어줌
    setTagBoxValue(value) {
      if (value == null || value == '') return []
      return value.split(',')
    },
    parseSplit(dataSourceList, strText, strSplit) {
      if (!strText) return ''

      let strList = strText.toString().split(strSplit)

      let strTextFilter = dataSourceList.filter(element => strList.includes(element.minorCd))
      let resultArray = []
      strTextFilter.forEach(element => resultArray.push(element.minorNm))
      return resultArray.join(strSplit + ' ')
    },
    onTagValueChanged(e, cellInfo) {
      cellInfo.setValue(e.value.join())
      cellInfo.component.selectRows(cellInfo.row.key, true)
    },
    displayTemplate(cellInfo) {
      let display = '[' + cellInfo.minorNm + ']  ' + (cellInfo.minorDesc == null ? '' : cellInfo.minorDesc)
      return display
    },
    fileListChange(id, el) {
      let obj = this.gridMain.find(item => item.id == id)
      obj.fileNm = el.fileNm
      obj.fileCount = el.fileCnt
      this.GetDataGrid(this.detailRef).saveEditData()
    },
    deleteCallBack(selectedMasterRows) {
      var index = null
      selectedMasterRows.forEach(key => {
        index = this.gridMain.findIndex(obj => obj == key)
        this.gridMain.splice(index, 1)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dx-master-detail-row .dx-row-focused .file_icon {
  color: #fff !important;
}
</style>
